module.exports = __webpack_public_path__ + "h5/img/Z5-start.c78e2746.jpg";